<script>
import adminTable from './mixins/adminTable'
export default
{

    mixins: [ adminTable ],

    data()
    {
        return {
            data: [],
            url: '/v1/admin/trackers',
            tableName: 'tableTrackers',
            emptyModel: { uid:null, bus_id: null, comment: null},
            columns: [ 'id', 'uid', 'comment', 'bus', 'battery', 'last_date', 'actions'],
            options: {
                headings: {
                    uid: this.$t('GENERAL.UID'),
                    comment: this.$t('ARTIST.NAME'),
                    bus: this.$t('MENU.BUS'),
                    actions: this.$t('TABLE.ACTIONS'),
                    battery: this.$t('GENERAL.BATTERY'),
                    last_date: this.$t('GENERAL.LAST_DATA_DATE'),
                },
                perPage: 50,
                perPageValues: [10, 25, 50, 100, 200, 400],
                saveState: true,
                highlightMatches: true,
                filterByColumn: true,
                columnsDropdown: true,
                toMomentFormat: true,
            }
        }
    },
}
</script>

<template>
    <div class="container-fluid">
        <mv-modal ref="form">
            <span slot="header">{{ $t('GENERAL.EDIT') }}</span>
            <mv-tracker-form :model="model" :edit="formEdit" @save="saveForm"></mv-tracker-form>
            <div slot="footer">
                <button class="btn btn-success" @click="closeForm">{{ $t('GENERAL.CANCEL') }}</button>
                <button class="btn btn-primary" @click="saveForm">{{ $t('GENERAL.SAVE') }}</button>
            </div>
        </mv-modal>
        <div class="panel panel-primary">
            <div class="panel-heading">
                <div class="row">
                    <div class="col-sm-10">
                        <h4>{{ $t('MENU.TRACKERS') }}</h4>
                    </div>
                </div>
            </div>
            <div class="panel-body">
                <v-client-table :data="data" :columns="columns" :options="options" :name="tableName" ref="table">
                    <div slot="actions" slot-scope="props" class="text-center">
                        <button class="btn btn-xs btn-warning" @click="delModel(props.row, props.row.name)">
                            <icon name="remove"></icon>
                        </button>
                        <button class="btn btn-xs btn-primary" @click="updateModel(props.row)">
                            <icon name="edit"></icon>
                        </button>
                    </div>
                    <div slot="bus" slot-scope="props">
                        <div v-if="props.row.bus && props.row.bus && props.row.bus.name">
                            {{ props.row.bus.name }}
                        </div>
                    </div>
                    <div slot="battery" slot-scope="props">
                        <div v-if="props.row.data && props.row.data[0]" class="text-center">
                            <mv-battery :voltage="props.row.data[0].batv" :percent="props.row.data[0].batp"></mv-battery>
                        </div>
                        <div v-else class="text-center">
                            <mv-battery></mv-battery>
                        </div>
                    </div>
                    <div slot="last_date" slot-scope="props">
                        <div v-if="props.row.data && props.row.data[0]" class="text-center">
                            <icon name="ban" v-if="!props.row.data[0].fix"></icon>
                            <icon name="question-circle" v-else-if="props.row.data[0].fix == 1"></icon>
                            <icon name="check" v-else-if="props.row.data[0].fix == 2"></icon>
                            <icon name="globe" v-else-if="props.row.data[0].fix > 2"></icon>
                            {{ props.row.data[0].created_at }}
                        </div>
                    </div>
                </v-client-table>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/pages/Trackers.vue